export type SchoolGuestOrderPosition = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  menuCode: string;
  quantity: number;
};

export type SchoolGuestOrderPayload = {
  comment?: string;
  editedBy: string;
  positions: { id?: number; menuCode: string; quantity: number }[];
  servingAt: SchoolGuestOrder["servingAt"];
};

export type SchoolGuestOrder = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  comment?: string | null;
  editedBy?: string | null;
  positions: SchoolGuestOrderPosition[];
  servingAt: `${number}-${number}-${number}`;
  cancelledAt?: string | null;
};
